import { render } from "./BotPositionsList.vue?vue&type=template&id=6c68321a&scoped=true"
import script from "./BotPositionsList.vue?vue&type=script&lang=js"
export * from "./BotPositionsList.vue?vue&type=script&lang=js"

import "./BotPositionsList.vue?vue&type=style&index=0&id=6c68321a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c68321a"]])

export default __exports__